var map = {
	"./background.jpg": "1100",
	"./bacteria.jpg": "9dcf",
	"./badicause.jpg": "dc06",
	"./cheatsheet/cheatsheet.jpg": "8016",
	"./demo.jpg": "9ffd",
	"./documents/2018/SPIADI2018 - Rapport annuel d'activité.pdf": "d484",
	"./documents/2019/SPIADI2019 - Article S. capitis.pdf": "6df9",
	"./documents/2019/SPIADI2019 - Rapport National.pdf": "4f61",
	"./documents/2019/SPIADI2019 - Rapport annuel d'activité.pdf": "6f28",
	"./documents/2019/SPIADI2019.zip": "98e2",
	"./documents/2020/OBSERVA4.zip": "6022",
	"./documents/2020/REASINK.zip": "0610",
	"./documents/2020/SPIADI2020 - Rapport National.pdf": "6db2",
	"./documents/2020/SPIADI2020 - Rapport OBSERVA4 provisoire - mai 2021.pdf": "e604",
	"./documents/2020/SPIADI2020 - Rapport annuel d'activité.pdf": "5bd9",
	"./documents/2020/SPIADI2020.zip": "38d2",
	"./documents/2021/OBSERVA4.zip": "5112",
	"./documents/2021/REAEXPLAUR.zip": "7e97",
	"./documents/2021/SPIADI2021 - Rapport National provisoire - juin 2022.pdf": "26aa",
	"./documents/2021/SPIADI2021 - Rapport OBSERVA4 provisoire - février 2022.pdf": "8801",
	"./documents/2021/SPIADI2021 - Rapport RÉA explAUR.pdf": "5ef4",
	"./documents/2021/SPIADI2021 - Rapport annuel d'activité.pdf": "57e8",
	"./documents/2021/SPIADI2021.zip": "de2f",
	"./documents/2022/CLEANHAND4.zip": "9142",
	"./documents/2022/ECHOGUIDAGE.zip": "00d5",
	"./documents/2022/OBSERVA4.zip": "c998",
	"./documents/2022/REAEXPLAUR.zip": "c378",
	"./documents/2022/SPIADI2022 - Rapport National provisoire - juillet 2023.pdf": "fc37",
	"./documents/2022/SPIADI2022 - Rapport OBSERVA4 provisoire - juillet 2023.pdf": "9c99",
	"./documents/2022/SPIADI2022 - Rapport RÉA explAUR.pdf": "c1f5",
	"./documents/2022/SPIADI2022 - Rapport annuel d'activité.pdf": "c25f",
	"./documents/2022/SPIADI2022 - Rapport national CLEANHAND4.pdf": "985f",
	"./documents/2022/SPIADI2022 - Rapport national Échoguidage.pdf": "66ae",
	"./documents/2022/SPIADI2022.zip": "2dfd",
	"./documents/2023/CLEANHANDPROX.zip": "b608",
	"./documents/2023/OBSERVA4.zip": "02f8",
	"./documents/2023/REAEXPLAUR.zip": "2380",
	"./documents/2023/SPIADI2023 - Rapport National CleanHand PROX - juin 2024.pdf": "fe03",
	"./documents/2023/SPIADI2023 - Rapport National RÉA explAUR - juin 2024.pdf": "69e3",
	"./documents/2023/SPIADI2023 - Rapport National provisoire - juin 2024.pdf": "64ba",
	"./documents/2023/SPIADI2023 - Rapport annuel d'activité.pdf": "d93c",
	"./documents/2023/SPIADI2023 - Rapport national OBSERVA4 - juillet 2024.pdf": "a094",
	"./documents/2023/SPIADI2023.zip": "32bf",
	"./documents/2024/CHRONOBIOLINE.zip": "3265",
	"./documents/2024/OBSERVA4.zip": "3ae6",
	"./documents/2024/REAEXPLAUR.zip": "623b",
	"./documents/2024/SPIADI2024 - Rapport annuel d'activité.pdf": "1eae",
	"./documents/2024/SPIADI2024 - Rapport national OBSERVA4 - janvier 2026.pdf": "d832",
	"./documents/2024/SPIADI2024 - Rapport national surveillance - janvier 2026.pdf": "1a46",
	"./documents/2024/SPIADI2024.zip": "530e",
	"./documents/2025/REAEXPLAUR.zip": "d322",
	"./documents/2025/SPIADI2024-2025 - Rapport National RÉA explAUR - juillet 2026.pdf": "592f",
	"./documents/2025/SPIADI2025 - Rapport annuel d'activité.pdf": "a2dd",
	"./documents/2025/SPIADI2025 - Rapport national OBSERVA4 - octobre 2026.pdf": "47bc",
	"./documents/2025/SPIADI2025 - Rapport national surveillance - octobre 2026.pdf": "45af",
	"./documents/Mission Day/2019/dupont.pdf": "c94d",
	"./documents/Mission Day/2019/lamy.pdf": "8b88",
	"./documents/Mission Day/2019/lepelletier.pdf": "7e5f",
	"./documents/Mission Day/2019/nvdm.pdf": "4fef",
	"./documents/Mission Day/2019/zingg.pdf": "b16b",
	"./documents/Mission Day/2020/gagneux brunon.pdf": "31dd",
	"./documents/Mission Day/2020/laurent.pdf": "483b",
	"./documents/Mission Day/2020/mourlan.pdf": "9f32",
	"./documents/Mission Day/2020/nvdm.pdf": "ac21",
	"./documents/Mission Day/2020/observa4.pdf": "51ee",
	"./documents/Mission Day/2020/pneumopathies.pdf": "0259",
	"./documents/Mission Day/2020/rea sink.pdf": "fa4b",
	"./documents/Mission Day/2020/valentin.pdf": "bd1c",
	"./documents/Mission Day/2020/zahar.pdf": "eaed",
	"./documents/Mission Day/2021/Appel à communication 7-10.pdf": "f654",
	"./documents/Mission Day/2021/Bulletin labos 7-10.pdf": "fe6a",
	"./documents/Mission Day/2021/Bulletin établissements 7-10.pdf": "7f97",
	"./documents/Mission Day/2021/Programme journée 7-10.pdf": "962b",
	"./documents/Mission Day/2021/berger.pdf": "8c27",
	"./documents/Mission Day/2021/berthelot.pdf": "49ca",
	"./documents/Mission Day/2021/caen.pdf": "0e3e",
	"./documents/Mission Day/2021/explaur.pdf": "0b4b",
	"./documents/Mission Day/2021/observa4.pdf": "5f22",
	"./documents/Mission Day/2021/pulcini.pdf": "0cb7",
	"./documents/Mission Day/2021/remi.pdf": "896f",
	"./documents/Mission Day/2021/surv.pdf": "d648",
	"./documents/Mission Day/2021/timsit.pdf": "bdbe",
	"./documents/Mission Day/2022/buetti-cvp.pdf": "f8c0",
	"./documents/Mission Day/2022/buetti-echo.pdf": "241b",
	"./documents/Mission Day/2022/buetti-news.pdf": "e016",
	"./documents/Mission Day/2022/deepcath.pdf": "3ad4",
	"./documents/Mission Day/2022/echo.pdf": "0daf",
	"./documents/Mission Day/2022/ght.pdf": "6c4d",
	"./documents/Mission Day/2022/llorens.pdf": "26cb",
	"./documents/Mission Day/2022/mathilde.pdf": "e4aa",
	"./documents/Mission Day/2022/nancy.pdf": "0c41",
	"./documents/Mission Day/2022/nephrocare.pdf": "dd31",
	"./documents/Mission Day/2022/nvdm.pdf": "616c",
	"./documents/Mission Day/2022/observa4.pdf": "6016",
	"./documents/Mission Day/2022/pad.pdf": "6ccc",
	"./documents/Mission Day/2022/patient.pdf": "3b82",
	"./documents/Mission Day/2022/piccmid.pdf": "b53c",
	"./documents/Mission Day/2022/rexmid.pdf": "a6cb",
	"./documents/Mission Day/2022/ville.pdf": "1a43",
	"./documents/Mission Day/2023/aphp.pdf": "52ec",
	"./documents/Mission Day/2023/cateau.pdf": "08d7",
	"./documents/Mission Day/2023/chp.pdf": "f4007",
	"./documents/Mission Day/2023/deepcath.pdf": "4ed1",
	"./documents/Mission Day/2023/denain.pdf": "d24a",
	"./documents/Mission Day/2023/gras.pdf": "e838",
	"./documents/Mission Day/2023/guerraoui.pdf": "d48b",
	"./documents/Mission Day/2023/limoges.pdf": "aaea",
	"./documents/Mission Day/2023/observation.pdf": "971f",
	"./documents/Mission Day/2023/roubaix.pdf": "9ad5",
	"./documents/Mission Day/2023/surveillance.pdf": "b80e",
	"./documents/Mission Day/2023/tours.pdf": "f335",
	"./documents/Mission Day/2023/tropi4.pdf": "6d3b",
	"./documents/Mission Day/2023/zahar.pdf": "6154",
	"./documents/Mission Day/2024/SPIADI2024 - Journée Nationale - Appel à communication.pdf": "3795",
	"./documents/Mission Day/2024/SPIADI2024 - Journée Nationale - Bulletin d'inscription.pdf": "ab9f",
	"./documents/Mission Day/2024/SPIADI2024 - Journée Nationale - Espace Partenaires.pdf": "e9bd",
	"./documents/Mission Day/2024/SPIADI2024 - Journée Nationale - Pré-Programme.pdf": "7acf",
	"./documents/Mission Day/2024/bourgain.pdf": "7fcb",
	"./documents/Mission Day/2024/farizon-borges.pdf": "3e2a",
	"./documents/Mission Day/2024/farizon.pdf": "82f5",
	"./documents/Mission Day/2024/folliot.pdf": "2e40",
	"./documents/Mission Day/2024/foucaut.pdf": "7da3",
	"./documents/Mission Day/2024/ilunga.pdf": "5f1c",
	"./documents/Mission Day/2024/laurans.pdf": "2a97",
	"./documents/Mission Day/2024/petit.pdf": "933a",
	"./documents/Mission Day/2024/pougheon.pdf": "72ad",
	"./documents/Mission Day/2024/ruckly.pdf": "598f",
	"./documents/Mission Day/2024/van-der-mee-valentin.pdf": "6e52",
	"./documents/Mission Day/2025/SPIADI2025 - Journée Nationale - Appel à communication.pdf": "d66b2",
	"./documents/Mission Day/2025/SPIADI2025 - Journée Nationale - Bulletin d'inscription.pdf": "ef0d",
	"./documents/Mission Day/2025/SPIADI2025 - Journée Nationale - Espace Partenaires.pdf": "b40b",
	"./documents/Mission Day/2025/SPIADI2025 - Journée Nationale - Programme.pdf": "4b35",
	"./documents/Mission Day/2025/dussartre.pdf": "176a",
	"./documents/Mission Day/2025/farizon-vilsans.pdf": "fb7e",
	"./documents/Mission Day/2025/feuillerat.pdf": "3ebf",
	"./documents/Mission Day/2025/folliot.pdf": "2fe4",
	"./documents/Mission Day/2025/hays.pdf": "bb11",
	"./documents/Mission Day/2025/mimoz.pdf": "0bc5",
	"./documents/Mission Day/2025/picaud.pdf": "b1b0",
	"./documents/Mission Day/2025/poulain.pdf": "a27f",
	"./documents/Mission Day/2025/rodriguez.pdf": "108f",
	"./documents/Mission Day/2025/siAli.pdf": "5d56",
	"./documents/Mission Day/2025/tartrais.pdf": "f3f8",
	"./documents/Mission Day/2025/trivier.pdf": "3798",
	"./documents/Mission Day/2025/valentin-vilsans.pdf": "72ba",
	"./documents/Mission Day/2025/van-der-mee-valentin.pdf": "70e4",
	"./documents/Mission Day/2025/vergnes.pdf": "1923",
	"./documents/Mission Day/2026/SPIADI2026 - Journée Nationale - Appel à communication.pdf": "fb08",
	"./documents/Mission Day/2026/SPIADI2026 - Journée Nationale - Bulletin d'inscription.pdf": "03ce",
	"./documents/Mission Day/2026/SPIADI2026 - Journée Nationale - Programme.pdf": "fce0",
	"./documents/annexes/SPIADI2025 - Annexe Catheters.pdf": "94e3",
	"./documents/annexes/SPIADI2026 - Annexe Codage disciplines et spécialités.pdf": "c461",
	"./documents/annexes/SPIADI2026 - Annexe Definition et diagnostic des pneumopathies.pdf": "0422",
	"./documents/annexes/SPIADI2026 - Annexe Détection BAS.pdf": "0ed8",
	"./documents/annexes/SPIADI2026 - Annexe Détection BLC.pdf": "0328",
	"./documents/annexes/SPIADI2026 - Annexe Micro-organismes.pdf": "0560",
	"./documents/annexes/SPIADI2026 - Annexe Réa Definition et diagnostic COL ILC BLC et SEPSIS.pdf": "f3ac",
	"./documents/annexes/SPIADI2026 - Annexe Score de sévérité.pdf": "8399",
	"./documents/bactADI/SPIADI2026 - BACT ADI+ - Fiche.pdf": "5b09",
	"./documents/bactADI/SPIADI2026 - BACT ADI+ - Guide Technique (Version 2).pdf": "66cc",
	"./documents/bactADI/SPIADI2026 - BACT ADI+.xlsx": "5b9e",
	"./documents/badiCause/SPIADI2026 - BADICAUSE - Fiche 1 - CVC, CCI, CVO, PICC, CDIA ou midline avec prolongateur intégré (Version 1).pdf": "ea0d",
	"./documents/badiCause/SPIADI2026 - BADICAUSE - Fiche 2 - CVP court ou midline sans prolongateur intégré (Version 1).pdf": "da41",
	"./documents/badiCause/SPIADI2026 - BADICAUSE - Guide Technique.pdf": "82dc",
	"./documents/expADI/SPIADI2026 - EXP ADI - Fiche Bactériémie.pdf": "1449",
	"./documents/expADI/SPIADI2026 - EXP ADI - Fiche Pneumopathie.pdf": "6a90",
	"./documents/expADI/SPIADI2026 - EXP ADI - Fiche Sepsis.pdf": "ab01",
	"./documents/expADI/SPIADI2026 - EXP ADI - Guide Technique (Version 2).pdf": "39c8",
	"./documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Dia.pdf": "4d06",
	"./documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Général (Version 2).pdf": "7672",
	"./documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Néo.pdf": "62e44",
	"./documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Onco (Version 2).pdf": "024b",
	"./documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Réa AD PED (Version 2).pdf": "fc55",
	"./documents/expADI/SPIADI2026 - EXP ADI.xlsx": "3c47",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche B1 (Version 2).pdf": "03c5",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche B2 (Version 2).pdf": "ffbd",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P1 (Version 1).pdf": "0f79",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P2 (Version 1).pdf": "6142",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P3 (Version 1).pdf": "a4a5",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P4 (Version 1).pdf": "5595",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P5 (Version 1).pdf": "e977",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Fiche R1 (Version 1).pdf": "41d0",
	"./documents/observa4/SPIADI2026 - OBSERVA4 - Guide Technique.pdf": "f07c",
	"./documents/reaExplaur/SPIADI2026 - RÉA EXPL AUR - Fiche Patient.pdf": "b288",
	"./documents/reaExplaur/SPIADI2026 - RÉA EXPL AUR - Fiche Service.pdf": "0768",
	"./documents/reaExplaur/SPIADI2026 - RÉA EXPL AUR - Guide Technique.pdf": "312b",
	"./documents/reaInfADI/SPIADI2026 - DIA INF ADI - Fiche.pdf": "53ef",
	"./documents/reaInfADI/SPIADI2026 - DIA INF ADI - Guide Technique (Version 2).pdf": "9006",
	"./documents/reaInfADI/SPIADI2026 - DIA INF ADI.xlsx": "6c19",
	"./documents/reaInfADI/SPIADI2026 - NÉO INF ADI - Fiche.pdf": "4634",
	"./documents/reaInfADI/SPIADI2026 - NÉO INF ADI - Guide Technique.pdf": "9b1b",
	"./documents/reaInfADI/SPIADI2026 - NÉO INF ADI.xlsx": "3487",
	"./documents/reaInfADI/SPIADI2026 - RÉA INF ADI - AD PED - Fiche.pdf": "eb43",
	"./documents/reaInfADI/SPIADI2026 - RÉA INF ADI - AD PED - Guide Technique (Version 2).pdf": "f9d5",
	"./documents/reaInfADI/SPIADI2026 - RÉA INF ADI - AD PED.xlsx": "fcd3",
	"./documents/spiadi/SPIADI2025.pdf": "6c7e",
	"./documents/spiadi/SPIADI2026 - Fiche données d'activité - dénominateurs.pdf": "f7b2",
	"./documents/spiadi/SPIADI2026 - Fiche établissement.pdf": "669d",
	"./documents/spiadi/SPIADI2026 - Procédure envoi fichier import.pdf": "131c",
	"./documents/spy4/SPIADI2026 - SPY4 - Fiche (Version 1).pdf": "abb7",
	"./documents/spy4/SPIADI2026 - SPY4 - Guide Technique.pdf": "47a0",
	"./documents/tools/SPADI2021 - GESTION MANIPULATIONS RETRAIT CVC EN NEONATOLOGIE-V1.pdf": "489f",
	"./documents/tools/SPIADI2022 - POSE D'UN CVC EN NEONATALOGIE - V2.pdf": "0ee7",
	"./documents/tools/SPIADI2022 - PRÉVENTION DES INFECTIONS LIÉES À UN CATHÉTER.pdf": "b399",
	"./documents/tools/SPIADI2022 - PRÉVENTION DES INFECTIONS LIÉES À UN CVP.pdf": "fe11",
	"./documents/tools/SPIADI2022 - RÉA-SINK.pdf": "df2c",
	"./documents/tools/lily/cvp/SPIADI - Affiche Lily.pdf": "2229",
	"./documents/tools/lily/cvp/SPIADI - Guide Pratique Lily.pdf": "ff4b",
	"./documents/tools/lily/ktReco/SPIADI - Synthèse des recommandations - CVP courts et midline sans PI.pdf": "c3ac",
	"./documents/tools/lily/ktReco/SPIADI - Synthèse des recommandations - cathéters centraux.pdf": "8d97",
	"./documents/tools/lily/ktReco/SPIADI - Synthèse des recommandations - midline avec PI.pdf": "9bb1",
	"./documents/tools/lily/valve/SPIADI - Guide Pratique Lily 2.pdf": "9ca3",
	"./documents/topCvp/SPIADI2025 - TOP CVP - Aide à la saisie de la Fiche Service (Version 2).xlsx": "3e8f",
	"./documents/topCvp/SPIADI2025 - TOP CVP - Fiche Maintien du CVP.pdf": "5448",
	"./documents/topCvp/SPIADI2025 - TOP CVP - Fiche Patient Bactériémique.pdf": "cc8b",
	"./documents/topCvp/SPIADI2025 - TOP CVP - Fiche Service (Version 2).pdf": "9a78",
	"./documents/topCvp/SPIADI2025 - TOP CVP - Guide Technique (Version 2).pdf": "5522",
	"./documents/valuation/communications/AUTRES/2019/SPIADI2019 - Présentation JHH.pdf": "f0ff",
	"./documents/valuation/communications/AUTRES/2019/SPIADI2019 - Présentation PHW.pdf": "dc7c",
	"./documents/valuation/communications/ECCMID/2019/SPIADI2019 - Abstract ECCMID.pdf": "b275",
	"./documents/valuation/communications/ECCMID/2019/SPIADI2019 - Poster ECCMID.pdf": "04eb",
	"./documents/valuation/communications/ECCMID/2020/SPIADI2020 - Abstract - Nation-wide survey of catheter-related bloodstream infections in medical, surgical and intensive care settings.pdf": "02cf",
	"./documents/valuation/communications/ECCMID/2020/SPIADI2020 - Abstract - Short-term peripheral venous catheter-related bloodstream infections in French healthcare settings.pdf": "bd30",
	"./documents/valuation/communications/ECCMID/2022/SPIADI2022 - A prospective multicenter observational study of insertion and use of central lines in the intensive care unit.pdf": "c92c",
	"./documents/valuation/communications/ECCMID/2023/SPIADI2023 - A multicenter observational study of the use of ultrasound guidance during central catheter insertion.pdf": "76f0",
	"./documents/valuation/communications/ECCMID/2024/SPIADI2024 - Impact of sterile gloving during proximal manipulation of a central venous catheter-the multicentre study CleanHandPROX.pdf": "7946",
	"./documents/valuation/communications/GIFAV/2019/SPIADI2019 - Poster GIFAV.pdf": "5c6e",
	"./documents/valuation/communications/RICAI/2019/SPIADI2019 - Présentation RICAI.pdf": "ca47",
	"./documents/valuation/communications/RICAI/2019/SPIADI2019 - Présentation RICAI_backup.pdf": "9279",
	"./documents/valuation/communications/RICAI/2021/RICAI2021.pdf": "c06d",
	"./documents/valuation/communications/RICAI/2021/ricai_spiadi_2021.pdf": "a42e",
	"./documents/valuation/communications/SF2H/2021/capitis2021.pdf": "9e36",
	"./documents/valuation/communications/SF2H/2022/SPIADI2022 - SF2H - Les bactériémies liées à un Midline aujourd'hui en France.pdf": "19b5",
	"./documents/valuation/communications/SF2H/2022/SPIADI2022 - SF2H - Les bactériémies liées à un PICCline aujourd'hui.pdf": "0dc6",
	"./documents/valuation/communications/SF2H/2022/SPIADI2022 - SF2H - Étude observationnelle multicentrique de l'hygiène des mains dans les services de long séjour et en EHPAD, 2021.pdf": "a657",
	"./documents/valuation/communications/SF2H/2022/SPIADI2022 - SF2H - Étude observationnelle multicentrique de l'hygiène des mains pour la pose des cathéters et la manipulation des lignes.pdf": "088b",
	"./documents/valuation/communications/SF2H/2022/SPIADI2022 - SF2H - Étude observationnelle prospective multicentrique de la pose et de l'utilisation des PICCLINES.pdf": "5d01",
	"./documents/valuation/communications/SF2H/2022/SPIADI2022 - VALV'FRICTION - un outil pédagogique pour améliorer l'utilisation des valves bidirectionnelles.pdf": "f14b",
	"./documents/valuation/communications/SF2H/2024/SPIADI2024 - Etude multicentrique CleanHandPROX.pdf": "6462",
	"./documents/valuation/communications/SF2H/2025/SPIADI2025 - Etude multicentrique des bactériémies liées aux dispositifs invasifs chez les personnes âgées 2020-2024.pdf": "1888",
	"./documents/valuation/communications/SF2H/2025/SPIADI2025 - Etude observationnelle HDM en Neonatologie.pdf": "5844",
	"./documents/valuation/communications/SF2H/2025/SPIADI2025 - Les bactériémies liées à un cathéter en EHPAD aujourd’hui - résultats SPIADI.pdf": "02e7",
	"./documents/valuation/communications/SF2H/2025/SPIADI2025 - Les infections liées à un cathéter en Néonatologie - résultats ChronoBIOline.pdf": "9bd4",
	"./documents/valuation/communications/SFAR/2019/SPIADI2019 - Réa Inf ADI.pdf": "8a9d",
	"./documents/valuation/communications/SFAR/2020/SPIADI2020 - Réa sink.pdf": "eccf",
	"./documents/valuation/communications/SFAR/2021/SPIADI2021 - Poster.pdf": "5825",
	"./documents/valuation/communications/SFAR/2023/SPIADI2023 - SFAR.pdf": "2678",
	"./documents/valuation/communications/SFAV/2019/SPIADI2019 - Présentation SFAV.pdf": "ba09",
	"./documents/valuation/communications/SFAV/2022/SPIADI2022 - SFAV - Surveillance prospective et Prévention des infections liées à un site d’accès vasculaire pour la dialyse, données nationales 2019-2021.pdf": "6e4b",
	"./documents/valuation/communications/SFAV/2023/SPIADI2023 - SFAV.pdf": "2cb4",
	"./documents/valuation/communications/SRLF/2021/SPIADI2021 - Présentation SRLF.pdf": "67f1",
	"./documents/valuation/communications/SRLF/2023/SPIADI2023 - Présentation SRLF.pdf": "2ad7",
	"./documents/valuation/communications/SRLF/2024/SPIADI2024 - Présentation SRLF.pdf": "7eee9",
	"./documents/valuation/publications/ChronoBIOline.pdf": "32c5",
	"./documents/valuation/publications/CleanHandPROX.pdf": "11b4",
	"./documents/valuation/publications/EHPAD-SPIADI-2020-2024.pdf": "2da4",
	"./documents/valuation/publications/cleanhand4.pdf": "a1ea",
	"./documents/valuation/publications/echo.pdf": "d014",
	"./documents/valuation/publications/hemato.pdf": "0992",
	"./documents/valuation/publications/reaexplaur.pdf": "5b09d",
	"./documents/valuation/publications/reasink.pdf": "9a24",
	"./img/cleanhand4/banner.jpg": "3fe8",
	"./img/cleanhand4/box.jpg": "23df",
	"./img/cleanhand4/guide.jpg": "3511",
	"./img/cleanhand4/guidevideo.jpg": "f334",
	"./img/cleanhand4/poster.jpg": "635c",
	"./img/cleanhandprox/banner.jpg": "9cea",
	"./img/cleanhandprox/guide.jpg": "193d",
	"./img/cleanhandprox/poster.jpg": "d45b",
	"./img/cleanhandprox/slide.jpg": "1504",
	"./img/gloves/banner.jpg": "f16e",
	"./img/gloves/guide.jpg": "3e3a",
	"./img/gloves/poster.jpg": "c2af",
	"./img/gloves/slide.jpg": "6dc2",
	"./img/groups/logo-ppp.png": "355c",
	"./img/groups/logo-success.png": "aa93",
	"./img/groups/planning-ppp-1.png": "6b81",
	"./img/groups/planning-ppp-2.png": "25c3",
	"./img/groups/planning-ppp.png": "5864",
	"./img/groups/planning-success.png": "3ce7",
	"./img/help-carousel.jpg": "05aa",
	"./img/lily/cvp/banner.jpg": "79b2",
	"./img/lily/cvp/guide.jpg": "db02",
	"./img/lily/cvp/poster.jpg": "7f13",
	"./img/lily/cvp/slide.jpg": "9977",
	"./img/lily/ktReco/banner.jpg": "0a28",
	"./img/lily/ktReco/central.jpg": "0d8d",
	"./img/lily/ktReco/mid.jpg": "490d",
	"./img/lily/ktReco/peri.jpg": "2e36",
	"./img/lily/valve/banner.jpg": "758c",
	"./img/lily/valve/guide.jpg": "8010",
	"./img/lily/valve/poster.jpg": "2018",
	"./img/lily/valve/slide.jpg": "ebfa",
	"./img/logo-bilanlin.png": "cdd5",
	"./img/logo-ecdc.png": "fbd3",
	"./img/logo-ligue.jpg": "02f7",
	"./img/logo-propias.png": "d9d0",
	"./img/logo-repias.png": "c200",
	"./img/logo-spf.svg": "6e19",
	"./img/logo-spy4.png": "fd32",
	"./img/logo-topcvp.png": "2153",
	"./img/logo-tours-evenements.png": "23e5",
	"./img/midline/banner.jpg": "a988",
	"./img/midline/guide.jpg": "9dd7",
	"./img/midline/poster.jpg": "174f",
	"./img/midline/slide.jpg": "c1e8",
	"./img/missionday-carousel.jpg": "2e05",
	"./img/missionday/2019/01.jpg": "97db",
	"./img/missionday/2019/02.jpg": "10a9",
	"./img/missionday/2019/03.jpg": "e083",
	"./img/missionday/2019/04.jpg": "e4d0",
	"./img/missionday/2019/05.jpg": "0706",
	"./img/missionday/2019/06.jpg": "d963",
	"./img/missionday/2019/07.jpg": "fbf5",
	"./img/missionday/2019/10.jpg": "c4f4",
	"./img/missionday/2019/12.jpg": "9f17",
	"./img/missionday/2019/13.jpg": "3c76",
	"./img/missionday/2019/14.jpg": "7eee",
	"./img/missionday/2019/brigitte_lamy.jpeg": "e0d4",
	"./img/missionday/2019/christian_dupont.jpeg": "a248",
	"./img/missionday/2019/didier_lepelletier.jpeg": "c8de",
	"./img/missionday/2019/nathalie_vandermee.jpg": "930a",
	"./img/missionday/2019/walter_zingg.jpeg": "17b0",
	"./img/missionday/2020/03.jpg": "e8a1",
	"./img/missionday/2020/05.jpg": "5078",
	"./img/missionday/2020/06.jpg": "8ae0",
	"./img/missionday/2020/07.jpg": "378a",
	"./img/missionday/2020/09.jpg": "c7f5",
	"./img/missionday/2020/11.jpg": "a468",
	"./img/missionday/2020/gagneux brunon.jpg": "f9d2",
	"./img/missionday/2020/laurent.jpg": "b9d4",
	"./img/missionday/2020/lily.jpg": "e073",
	"./img/missionday/2020/mourlan.jpg": "c4e6",
	"./img/missionday/2020/observa4.jpg": "9b8c",
	"./img/missionday/2020/pneu.jpg": "8ac7",
	"./img/missionday/2020/reasink.jpg": "cc3d",
	"./img/missionday/2020/spiadi.jpg": "0be3",
	"./img/missionday/2020/valentin.jpg": "089e",
	"./img/missionday/2020/valorisation.jpg": "a82f",
	"./img/missionday/2020/zahar.jpg": "2b49",
	"./img/missionday/2021/03.jpg": "c808",
	"./img/missionday/2021/04.jpg": "d3ec",
	"./img/missionday/2021/05.jpg": "28af",
	"./img/missionday/2021/06.jpg": "db2c",
	"./img/missionday/2021/07.jpg": "a01e",
	"./img/missionday/2021/08.jpg": "aa05",
	"./img/missionday/2021/berger.jpg": "c46a",
	"./img/missionday/2021/berthelot.jpg": "f23d",
	"./img/missionday/2021/caen.jpg": "9c5c",
	"./img/missionday/2021/explaur.jpg": "f19b",
	"./img/missionday/2021/lily.jpg": "d673",
	"./img/missionday/2021/observa4.jpg": "8142",
	"./img/missionday/2021/pulcini.jpg": "2796",
	"./img/missionday/2021/remi.jpg": "c8cb",
	"./img/missionday/2021/surv.jpg": "f5ba",
	"./img/missionday/2021/timsit.jpg": "0335",
	"./img/missionday/2022/01.jpg": "8aec",
	"./img/missionday/2022/02.jpg": "a2c2",
	"./img/missionday/2022/03.jpg": "3073",
	"./img/missionday/2022/04.jpg": "ec25",
	"./img/missionday/2022/05.jpg": "0d81",
	"./img/missionday/2022/anneso.jpg": "25ea",
	"./img/missionday/2022/buetti-cvp.jpg": "1c9a",
	"./img/missionday/2022/buetti-echo.jpg": "32ff",
	"./img/missionday/2022/buetti-news.jpg": "1742",
	"./img/missionday/2022/deepcath.jpg": "4f25",
	"./img/missionday/2022/echo.jpg": "b7e5",
	"./img/missionday/2022/llorens.jpg": "e391",
	"./img/missionday/2022/mathilde.jpg": "e197",
	"./img/missionday/2022/nvdm.jpg": "bac6",
	"./img/missionday/2023/01.jpg": "f400",
	"./img/missionday/2023/02.jpg": "b9d2",
	"./img/missionday/2023/03.jpg": "a7a8",
	"./img/missionday/2023/04.jpg": "776a",
	"./img/missionday/2023/05.jpg": "ee58",
	"./img/missionday/2023/IMG_2647.jpg": "8443",
	"./img/missionday/2023/cateau.jpg": "93c5",
	"./img/missionday/2023/chp.jpg": "5ca5",
	"./img/missionday/2023/deepcath.jpg": "676f",
	"./img/missionday/2023/gras.jpg": "b53e",
	"./img/missionday/2023/guerraoui.jpg": "833f",
	"./img/missionday/2023/observation.jpg": "e668",
	"./img/missionday/2023/surveillance.jpg": "4be3",
	"./img/missionday/2023/tropi4.jpg": "a765",
	"./img/missionday/2023/zahar.jpg": "7d62",
	"./img/missionday/2024/01.jpg": "610a",
	"./img/missionday/2024/02.jpg": "0851",
	"./img/missionday/2024/03.jpg": "64d3",
	"./img/missionday/2024/05.jpg": "9996",
	"./img/missionday/2024/07.jpg": "59f8",
	"./img/missionday/2024/farizon-borges.jpg": "27d5",
	"./img/missionday/2024/farizon.jpg": "7b75",
	"./img/missionday/2024/hansen.jpg": "df63",
	"./img/missionday/2024/ilunga.jpg": "3fdf",
	"./img/missionday/2024/petit.jpg": "fa66",
	"./img/missionday/2024/pougheon.jpg": "eb2c",
	"./img/missionday/2024/ruckly.jpg": "22bc",
	"./img/missionday/2024/van-der-mee-valentin.jpg": "3253",
	"./img/missionday/2025/01.jpg": "f150",
	"./img/missionday/2025/02.jpg": "e187",
	"./img/missionday/2025/03.jpg": "97cc",
	"./img/missionday/2025/04.jpg": "39ea",
	"./img/missionday/2025/05.jpg": "c0a3",
	"./img/missionday/2025/deepvalv-draw.jpg": "0c8e",
	"./img/missionday/2025/farizon-draw.jpg": "98a4",
	"./img/missionday/2025/farizon-vilsans.jpg": "2450",
	"./img/missionday/2025/farizon.jpg": "e6b6",
	"./img/missionday/2025/hays-suchail-draw.jpg": "d09b",
	"./img/missionday/2025/hays-suchail.jpg": "73b9",
	"./img/missionday/2025/maris-draw.jpg": "e5a1",
	"./img/missionday/2025/maris.jpg": "aa62",
	"./img/missionday/2025/mimoz-draw.jpg": "039a",
	"./img/missionday/2025/mimoz.jpg": "3f7d",
	"./img/missionday/2025/observa4-draw.jpg": "4175",
	"./img/missionday/2025/observa4.jpg": "3298",
	"./img/missionday/2025/picaud-draw.jpg": "0010",
	"./img/missionday/2025/picaud.jpg": "862e",
	"./img/missionday/2025/poulain.jpg": "9d2c",
	"./img/missionday/2025/rodriguez-draw.jpg": "f721",
	"./img/missionday/2025/rodriguez.jpg": "5093",
	"./img/missionday/2025/si-ali.jpg": "01d9",
	"./img/missionday/2025/tartrais.jpg": "2530",
	"./img/missionday/2025/valentin-vilsans.jpg": "64b8",
	"./img/missionday/2025/van-der-mee.jpg": "5a98",
	"./img/missionday/2026/01.jpg": "8e5b",
	"./img/missionday/2026/02.jpg": "27df",
	"./img/missionday/2026/03.jpg": "08b4",
	"./img/missionday/2026/04.jpg": "c078",
	"./img/missionday/2026/05.jpg": "c718",
	"./img/missionday/2026/birgand.jpg": "6c44",
	"./img/missionday/2026/chazet.jpg": "69c3",
	"./img/missionday/2026/dussartre.jpg": "a66d",
	"./img/missionday/2026/farizon.jpg": "1271",
	"./img/missionday/2026/fort-farizon.jpg": "1a18",
	"./img/missionday/2026/kerneis.jpg": "42f8",
	"./img/missionday/2026/valentin.jpg": "8173",
	"./img/missionday/2026/van-der-mee.jpg": "d775",
	"./img/missionday/placeholder.png": "4f0f",
	"./img/missionday/qualiopi.jpg": "980e",
	"./img/outfit/banner.jpg": "e50a",
	"./img/outfit/guide.jpg": "1a1d",
	"./img/outfit/poster.jpg": "8f27",
	"./img/outfit/slide.jpg": "895a",
	"./img/valuation/communications/ECCMID_logo.jpg": "54ba",
	"./img/valuation/communications/GIFAV_logo.jpg": "8696",
	"./img/valuation/communications/REPIA_logo.png": "327e",
	"./img/valuation/communications/RICAI_logo.png": "2d3d",
	"./img/valuation/communications/SF2H_logo.jpg": "e19f",
	"./img/valuation/communications/SFAR_logo.jpg": "e80f",
	"./img/valuation/communications/SFAV_logo.jpeg": "d5fa",
	"./img/valuation/communications/SRLF_logo.jpg": "2525",
	"./img/valuation/publications/Annals_of_hematology_cover.jpg": "2e4b",
	"./img/valuation/publications/BMC_ARIC_cover.jpg": "123d",
	"./img/valuation/publications/BMC_EJMR_cover.jpg": "adc0",
	"./img/valuation/publications/BMC_ME_cover.jpg": "e532",
	"./img/valuation/publications/CMI_cover.jpg": "0ac2",
	"./img/valuation/publications/EJCMID_cover.jpg": "12a0",
	"./img/valuation/publications/Frontiers_in_microbiology_cover.jpg": "a64d",
	"./img/valuation/publications/Hygiènes_cover.jpg": "40b3",
	"./img/valuation/publications/microorganisms_cover.jpg": "00cf",
	"./ktreco.jpg": "d007",
	"./meeting.jpg": "47dd",
	"./research.jpg": "a19c",
	"./results.jpg": "d9d6",
	"./vinci.jpg": "37d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";